import React, { useEffect } from 'react'
import './CustomSwitch.css'
// import PosterCdnCheck from '../CreateListmoviespersons/PosterCdnCheck'
// import AwsConfig from '../../Config/AwsConfig'
// import { v4 as uuidv4 } from 'uuid'
// import axios from 'axios'
// import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'

const PNComponent = ({ inputData, sendinputdata, sendtruevalue, movieMode }) => {
  const handleChange = () => {
    const updatedInputData = { ...inputData, sendTFIDBPN: !inputData.sendTFIDBPN }
    sendinputdata(updatedInputData)
    sendtruevalue('sendTFIDBPN', true)
  }

  const handleInputChange = (field, value) => {
    const updatedInputData = {
      ...inputData,
      PNInfo: { ...inputData.PNInfo, [field]: value },
    }
    sendinputdata(updatedInputData)
  }

  useEffect(() => {
    // const updatedInputData = {
    //   ...inputData,
    // }
    if (movieMode === 'create') {
    const PNInfo = {
      title_En: inputData.PNInfo.title_En || inputData.movieName,
      title_Te: inputData.PNInfo.title_Te || inputData.movieNamete,
      description_En: inputData.PNInfo.description_En || inputData.Bio,
      description_Te: inputData.PNInfo.description_Te || inputData.biote,
    }

    const updatedInputData = {
      ...inputData,
      PNInfo,
    }

    sendinputdata(updatedInputData)
  }
  }, [inputData.sendTFIDBPN])

  // const uploadSelectedImage = async (field, urlImage) => {
  //   try {
  //     // const maxSize = 1024 * 1024 // 1MB
  //     // if (urlImage.size > maxSize) {
  //     //   // setRequiredImageSize(false)
  //     //   return
  //     // }

  //     const randomId = await uuidv4()
  //     const moviePath = AwsConfig.pnImagePath
  //     const key = `${moviePath}${randomId}.jpeg`

  //     const params = {
  //       key,
  //       mimeType: 'image/jpeg',
  //     }

  //     const preSignedURLObject = await getPreSignedURL(params)
  //     const { fields, url: signedURL } = preSignedURLObject.data

  //     const formData = new FormData()
  //     Object.entries(fields).forEach(([key, value]) => {
  //       formData.append(key, value)
  //     })
  //     formData.append('file', urlImage)

  //     await uploadToS3(signedURL, formData)
  //     handleInputChange(field, key)
  //   } catch (err) {
  //     console.warn(err, 'err')
  //     // Handle errors, provide user feedback, etc.
  //   }
  // }

  // const getPreSignedURL = async params => {
  //   const preSignedURLObject = await MovieImagePresignedUrl(params)
  //   return JSON.parse(preSignedURLObject.signedObject)
  // }

  // const uploadToS3 = async (signedURL, formData) => {
  //   await axios({
  //     method: 'post',
  //     url: signedURL,
  //     data: formData,
  //     headers: { 'Content-Type': 'multipart/form-data' },
  //   })
  // }

  // const handleImageUpload = (field, file) => {
  //   //
  //   uploadSelectedImage(field, file)
  // }

  return (
    <div style={{ marginTop: '5px' }}>
      <div style={{ display: 'flex', gap: '10px' }}>
        <label>Send Push Notifications:</label>
        <label className='custom-switch'>
          <input type='checkbox' checked={inputData.sendTFIDBPN} onChange={handleChange} />
          <span className='custom-slider'></span>
        </label>
      </div>
      {inputData.sendTFIDBPN && (
        <div>
          <div style={{ marginTop: '10px', display: 'flex', gap: '5px' }}>
            <div>
              <InputField
                label='PN Title (EN)'
                value={(inputData.PNInfo && inputData.PNInfo.title_En) || ''}
                onChange={e => handleInputChange('title_En', e.target.value)}
              />
              <TextAreaField
                label='PN Description (EN)'
                value={(inputData.PNInfo && inputData.PNInfo.description_En) || ''}
                onChange={e => handleInputChange('description_En', e.target.value)}
              />
            </div>
            <div>
              <InputField
                label='PN Title (TE)'
                value={(inputData.PNInfo && inputData.PNInfo.title_Te) || ''}
                onChange={e => handleInputChange('title_Te', e.target.value)}
              />
              <TextAreaField
                label='PN Description (TE)'
                value={(inputData.PNInfo && inputData.PNInfo.description_Te) || ''}
                onChange={e => handleInputChange('description_Te', e.target.value)}
              />
            </div>
          </div>
          <div>
            {/* <ImageUpload
              label='Upload PN Image'
              onChange={e => handleImageUpload('posterURL', e.target.files[0])}
            /> */}
            {/* <div
              style={{
                position: 'relative',
                left: '165px',
                top: '36px',
              }}
            >
              {inputData.PNInfo &&
                inputData.PNInfo.posterURL &&
                inputData.PNInfo.posterURL.length > 1 && (
                  <button
                    className='remove btn btn-danger'
                    type='button'
                    // onClick={() => sendPosterUrl('poster', '')}
                  >
                    X
                  </button>
                )}
            </div> */}
            {/* {} */}
            {/* {inputData.PNInfo && inputData.PNInfo && inputData.PNInfo.posterURL && (
              <img
                src={PosterCdnCheck(inputData.PNInfo && inputData.PNInfo.posterURL)}
                className='posterimage'
                // style={modeUrl && indication}
                alt='PN Poster'
                width='200'
                height='200'
              />
            )} */}
          </div>
        </div>
      )}
    </div>
  )
}

const InputField = ({ label, value, onChange }) => (
  <div>
    <label>{label}:</label>
    <input type='text' value={value} onChange={onChange} className='form-control' />
  </div>
)

const TextAreaField = ({ label, value, onChange }) => (
  <div>
    <label>{label}:</label>
    <textarea
      type='text'
      value={value || ''}
      onChange={onChange}
      rows={5}
      cols={20}
      className='form-control'
    />
  </div>
)

// const ImageUpload = ({ label, onChange }) => (
//   <div>
//     <label>{label}:</label>
//     <input type='file' accept='image/*' onChange={onChange} className='form-control' />
//   </div>
// )

export default PNComponent
